import CookiesConsent from "./CookiesConsent";

export default CookiesConsent;
